export default __webpack_public_path__ + "static/media/dbe10f22605e96c6.8d4891ba800c619d366f61635e479383.svg";